import Vue from "vue";
const randomize = require("randomatic");
export default Vue.extend({
  template: `
  <div>
  <v-date-picker
                          v-model="date"
                         @change="onDateChange"
                         :min="min"
                         :max="max"
                        ></v-date-picker>
                        </div>
  
    `,
  data: function () {
    return {
      date: "",
      min: null,
      max: null,
    };
  },

  mounted() {},

  methods: {
    getValue() {
      return this.date;
    },
    isPopup() {
      return true;
    },
    onDateChange(event) {
      if (this.params.data.isExtra) {
        const field = this.params.colDef.field;
        const extra = this.params.data.extras.find(
          (e) => e.id == this.params.data.id
        );
        if (extra) {
          extra[field] = this.date;
        }
      }
      this.params.data.id = randomize("Aa0", 32);
      this.params.api.stopEditing();
    },
  },
  beforeMount() {
    this.date = this.params.data[this.params.colDef.field];
    if (this.params.data.startDate && this.params.data.endDate) {
      this.min = new Date(this.params.data.startDate).toISOString();
      this.max = new Date(this.params.data.endDate).toISOString();
    }
  },
});



// WEBPACK FOOTER //
// ./src/components/gt/shared/ag-grid/AgCellDateEditor.js